import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';

import i18n from 'i18n-js';
import { timeFrames } from 'constants/pricing';
import { Autocomplete } from 'components/FormFields';
import { handleShowError, handleError, generateFilterOptions } from 'utils';

const TimeFrameSelect = ({
  label,
  variant,
  field: { name, value },
  form: { errors, touched, setFieldValue },
  omitFields,
  asyncErrors,
  margin,
  disabled,
}) => {
  const [defaultValue, setDefaultValue] = useState('');
  const filterOptions = generateFilterOptions('start', 'label');
  useEffect(() => {
    if (value || value === '') {
      const defaultVal = timeFrames.find((timeFrames) => timeFrames?.value === value);
      if (defaultVal) {
        setDefaultValue(i18n.t(`ruleset.timeframes.${defaultVal.label}`));
      } else {
        setDefaultValue('');
      }
    }
  }, [value, timeFrames]); // eslint-disable-line

  return (
    <Autocomplete
      id="timeFrames"
      openOnFocus
      label={label}
      disabled={disabled}
      margin={margin}
      variant={variant}
      inputValue={defaultValue}
      filterOptions={filterOptions}
      getOptionLabel={(option) => i18n.t(`ruleset.timeframes.${option.label}`)}
      error={handleError(name, errors, touched, asyncErrors)}
      options={timeFrames.filter((val) => omitFields.indexOf(val))}
      getOptionSelected={(option, value) => option === value || ''}
      onChange={(ev, val) => setFieldValue(name, val?.value || '')}
      onInputChange={(ev, val) => setDefaultValue(val?.label || '')}
      helperText={handleShowError(name, errors, touched, asyncErrors)}
    />
  );
};

TimeFrameSelect.propTypes = {
  label: PropTypes.string,
  asyncErrors: PropTypes.string,
  required: PropTypes.bool,
  disabled: PropTypes.bool,
  field: PropTypes.shape({
    value: PropTypes.any,
    name: PropTypes.string,
    onBlur: PropTypes.func,
    onChange: PropTypes.func,
  }),
  style: PropTypes.object,
  form: PropTypes.shape({
    errors: PropTypes.object,
    touched: PropTypes.object,
  }),
  variant: PropTypes.oneOf(['standard', 'outlined', 'filled']),
  omitFields: PropTypes.array,
};

TimeFrameSelect.defaultProps = {
  required: true,
  disabled: false,
  form: {
    errors: {},
    touched: {},
    setFieldValue: () => {},
  },
  style: {},
  field: {},
  variant: 'standard',
  label: 'Select a day',
  omitFields: [],
};

export default TimeFrameSelect;
